/* eslint @typescript-eslint/strict-boolean-expressions: off */

import createSanityClient from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";
import memoize from "lodash/memoize";
import { SanityRef } from "lib/sanity/types";
import { isBuildTime } from "lib/env/env";

// Get the lazy singleton Sanity SDK instance.
//
// * The client is configured the first time it is used.
// * Preview mode uses an auth token to fetch unpublished draft content.
// * For speed, the Sanity CDN should be used when fetching data for SSR.
// * For freshness, the CDN should not be used when fetching data for SSG.
//
export const sanity = memoize((preview = false) => {
  return createSanityClient({
    projectId: "fox336rh",
    dataset: "production",
    token: preview ? process.env.SANITY_TOKEN : undefined,
    useCdn: !preview && !isBuildTime(),
  });
});

export const image = (ref: SanityRef) => {
  return imageUrlBuilder(sanity()).image(ref);
};
